import { useState, useEffect } from "react";
import type {
  ArtistInstructionsArtwork,
  Question,
  ArtistInstructionsState
} from "./artist-instructions-types";
import { ARTIST_INSTRUCTIONS_STATES } from "./artist-instructions-types";

export function useArtistInstructionsState(artwork: ArtistInstructionsArtwork) {
  const [instructions, setInstructions] = useState("");
  const [questions, setQuestions] = useState<Question[]>([]);
  const [currentState, setCurrentState] = useState<ArtistInstructionsState>(
    ARTIST_INSTRUCTIONS_STATES.INITIAL
  );
  const [llmRedrawRequestId, setLlmRedrawRequestId] = useState<number | null>(null);

  // Initialize state from saved data if available
  useEffect(() => {
    if (artwork.llmInterpretationState) {
      setInstructions(artwork.llmInterpretationState.instructions || "");
      setQuestions(artwork.llmInterpretationState.questions || []);
      setCurrentState(artwork.llmInterpretationState.currentState as ArtistInstructionsState);
      setLlmRedrawRequestId(artwork.llmInterpretationState.llmRedrawRequestId || null);
    } else if (artwork.enhancementNote) {
      setInstructions(artwork.enhancementNote);
      setCurrentState(ARTIST_INSTRUCTIONS_STATES.TYPING);
    }
  }, [artwork]);

  return {
    instructions,
    setInstructions,
    questions,
    setQuestions,
    currentState,
    setCurrentState,
    llmRedrawRequestId,
    setLlmRedrawRequestId
  };
}
